import axios, { InternalAxiosRequestConfig } from 'axios';

const resolveApiBase = (): string => {
  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    if (host === 'localhost' || host === '127.0.0.1') {
      return 'http://localhost:8000/api';
    }
  }
  const envUrl = process.env.REACT_APP_API_URL;
  if (!envUrl) {
    const msg = 'REACT_APP_API_URL is not set in this build.';
    if (process.env.NODE_ENV === 'production') throw new Error(msg);
    // eslint-disable-next-line no-console
    console.warn(msg + ' Falling back to http://localhost:8000/api');
    return 'http://localhost:8000/api';
  }
  return envUrl;
};

export const api = axios.create({
  baseURL: resolveApiBase(),
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = localStorage.getItem('admin_token');
    if (token) {
      config.headers.set('Authorization', `Token ${token}`);
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('admin_token');
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
